import api from './api';

const recetaMenuConfigService = {
  getTiempos(params = {}) {
    return api.get('/recetas/tiempos', { params }).then((r) => r.data);
  },
  createTiempo(data) {
    return api.post('/recetas/tiempos', data).then((r) => r.data);
  },
  updateTiempo(id, data) {
    return api.put(`/recetas/tiempos/${id}`, data).then((r) => r.data);
  },
  deleteTiempo(id) {
    return api.delete(`/recetas/tiempos/${id}`).then((r) => r.data);
  },
  getTiposPlato(params = {}) {
    return api.get('/recetas/tipos-plato', { params }).then((r) => r.data);
  },
  createTipoPlato(data) {
    return api.post('/recetas/tipos-plato', data).then((r) => r.data);
  },
  updateTipoPlato(id, data) {
    return api.put(`/recetas/tipos-plato/${id}`, data).then((r) => r.data);
  },
  deleteTipoPlato(id) {
    return api.delete(`/recetas/tipos-plato/${id}`).then((r) => r.data);
  },
};

export default recetaMenuConfigService;
